import { render } from "./Pbx3cxReportsList.vue?vue&type=template&id=817ebb2c"
import script from "./Pbx3cxReportsList.vue?vue&type=script&lang=js"
export * from "./Pbx3cxReportsList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__